module.exports = __webpack_public_path__ + "assets/blocked-icon.svg";